<template>
  <div class="main-content statisticsOrders">
    <div class="card">
      <div class="card-header">
        <h6>Фильтр</h6>
      </div>
      <div class="card-body">
        <form @submit.prevent="search">
          <div class="row">
            <div class="col-md-4">
              <date-picker
                v-model="filter.date"
                type="date" range
                value-type="format"
                format="DD.MM.YYYY"
                @change="handleChangeDatePicker"
                :shortcuts="shortcuts"
                placeholder="Выберите дату"/>
            </div>
            <div class="col-md-4">
              <select class="form-control">
                <option value="-1" selected>Все заявки</option>
              </select>
            </div>
          </div>
          <div class="text-right">
            <vue-ladda button-class="btn btn-sm btn-success"
                       data-style="zoom-in"
                       type="submit"
                       :loading="loading">Поиск
            </vue-ladda>
          </div>
        </form>
      </div>
    </div>

    <div class="card" v-if="showResultBlock">
      <div class="card-body">
        <pulse-loader :loading="loading" :color="loadingColor" class="text-center"/>
        <div v-if="records">
          <StatisticChart :records="records"/>
        </div>
        <div v-else>
          <h4 v-if="!loading">Заявок не найдено</h4>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

  import api from '@/api'
  import VueLadda from 'vue-ladda/src/vue-ladda.vue'
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  import 'vue2-datepicker/locale/ru';
  import moment from 'moment'
  // import { Line } from 'vue-chartjs'
  // import {LineChart} from 'vue-chartjs'
  import StatisticChart from "./components/StatisticChart";

  export default {
    title: 'Статистика заявок',
    components: {
      VueLadda,
      DatePicker,
      StatisticChart,
      // LineChart,
    },
    data() {
      return {
        showResultBlock: false,
        loading: false,
        filter: {},
        records: null,
        loadingColor: this.$constants.LOADING_COLOR,
        chartData: {
          labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
          datasets: [{
            label: '# of Votes',
            data: [12, 19, 3, 5, 2, 3],
            backgroundColor: [
              'rgba(255, 99, 132, 0.2)',
              'rgba(54, 162, 235, 0.2)',
              'rgba(255, 206, 86, 0.2)',
              'rgba(75, 192, 192, 0.2)',
              'rgba(153, 102, 255, 0.2)',
              'rgba(255, 159, 64, 0.2)'
            ],
            borderColor: [
              'rgba(255, 99, 132, 1)',
              'rgba(54, 162, 235, 1)',
              'rgba(255, 206, 86, 1)',
              'rgba(75, 192, 192, 1)',
              'rgba(153, 102, 255, 1)',
              'rgba(255, 159, 64, 1)'
            ],
            borderWidth: 1
          }]
        },
        shortcuts: [
          {
            text: 'Тек. месяц',
            onClick() {
              const startOfMonth = moment().clone().startOf('month').format('YYYY-MM-DD');
              const endOfMonth = moment().clone().endOf('month').format('YYYY-MM-DD');
              return [new Date(startOfMonth), new Date(endOfMonth)];
            },
          },
          {
            text: 'Пр. месяц',
            onClick() {
              const startOfMonth = moment().clone().startOf('month').subtract(1, 'month').format('YYYY-MM-DD');
              const endOfMonth = moment(startOfMonth).clone().endOf('month').format('YYYY-MM-DD');
              return [new Date(startOfMonth), new Date(endOfMonth)];
            },
          },
          {
            text: 'За 3 месяца',
            onClick() {
              const startOfMonth = moment().clone().startOf('month').subtract(2, 'month').format('YYYY-MM-DD');
              const endOfMonth = moment().clone().endOf('month').format('YYYY-MM-DD');
              return [new Date(startOfMonth), new Date(endOfMonth)];
            },
          },
          {
            text: 'За 6 мес.',
            onClick() {
              const startOfMonth = moment().clone().startOf('month').subtract(5, 'month').format('YYYY-MM-DD');
              const endOfMonth = moment().clone().endOf('month').format('YYYY-MM-DD');
              return [new Date(startOfMonth), new Date(endOfMonth)];
            },
          },
          {
            text: 'За год',
            onClick() {
              const startOfMonth = moment().clone().startOf('month').subtract(12, 'month').format('YYYY-MM-DD');
              const endOfMonth = moment().clone().endOf('month').format('YYYY-MM-DD');
              return [new Date(startOfMonth), new Date(endOfMonth)];
            },
          },
        ],
      }
    },
    methods: {
      handleChangeDatePicker(value, type) {
      },
      async search() {
        this.showResultBlock = true;
        this.loading = true;
        this.records = null;
        console.log('submit', this.filter);
        let {data} = await api.post('/statistics/orders', {
          filter: this.filter,
        });
        if (!data.success) {
          this.Toast.fire({
            type: 'warning',
            title: data.message || 'Ошибка'
          })
        } else {
          this.records = data.records;
        }
        this.loading = false;
      }
    }
  }


</script>
